import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtilsService } from './http-utils.service';
import { Observable, catchError, map, mergeMap } from 'rxjs';
import { JsonConvert } from 'json2typescript';
import { Paging } from '../../model/paging/paging';
import { environment } from '../../../environment/environment';
import { AccountListData, Account } from '../../model/account/account';

@Injectable({
    providedIn: 'root'
})
export class AccountService {
    private _url: string = `${environment.baseAPI}/accounts`;

    constructor(private _http: HttpClient, private _httpUtils: HttpUtilsService) { }

    GETAccounts(paging: Paging): Observable<AccountListData | any> {
        try {
            return this._httpUtils.getHTTPHeadersAsyncTenant().pipe(
                mergeMap(httpHeaders => {
                    return this._http.get(`${this._url}${paging.getQs()}`, { headers: httpHeaders }).pipe(
                        map((res: any) => {
                            const jsonConvert: JsonConvert = new JsonConvert();
                            let response: AccountListData;
                            try {
                                response = jsonConvert.deserializeObject(res, AccountListData);
                            } catch (e) {
                                return res; // fallback: return raw response
                            }
                            if (response && response.data && response.data.data) {
                                response.data.data = response.data.data.map(acc => Account.normalizeLocationsGroups(acc));
                            }
                            if (response.success) {
                                return response;
                            } else {
                                this._httpUtils.handleError(response);
                                return;
                            }
                        }, catchError(err => {
                            if (err.status === 401) { this._httpUtils.logout(); }
                            throw err;
                        })));
                }), catchError(err => { throw err; })
            );
        } catch (error) {
            throw error;
        }
    }

    // Metodo per la modifica: POST su /accounts/{uuid}
    UPDATEAccount(uuid: string, data: any): Observable<any> {
        try {
            return this._httpUtils.getHTTPHeadersAsyncTenant().pipe(
                mergeMap(httpHeaders => {
                    return this._http.put(`${this._url}/${uuid}`, data, { headers: httpHeaders }).pipe(
                        map((res: any) => res),
                        catchError(err => {
                            if (err.status === 401) { this._httpUtils.logout(); }
                            throw err;
                        })
                    );
                }), catchError(err => { throw err; })
            );
        } catch (error) {
            throw error;
        }
    }

    // Metodo per la creazione: POST su /accounts
    POSTAccount(data: any): Observable<any> {
        try {
            return this._httpUtils.getHTTPHeadersAsyncTenant().pipe(
                mergeMap(httpHeaders => {
                    return this._http.post(`${this._url}`, data, { headers: httpHeaders }).pipe(
                        map((res: any) => res),
                        catchError(err => {
                            if (err.status === 401) { this._httpUtils.logout(); }
                            throw err;
                        })
                    );
                }), catchError(err => { throw err; })
            );
        } catch (error) {
            throw error;
        }
    }

    DELETEAccount(uuid: string): Observable<any> {
        try {
            return this._httpUtils.getHTTPHeadersAsyncTenant().pipe(
                mergeMap(httpHeaders => {
                    return this._http.delete(`${this._url}/${uuid}`, { headers: httpHeaders }).pipe(
                        map((res: any) => res),
                        catchError(err => {
                            if (err.status === 401) { this._httpUtils.logout(); }
                            throw err;
                        })
                    );
                }), catchError(err => { throw err; })
            );
        } catch (error) {
            throw error;
        }
    }
}